<template>
    <section class="g-container || o-band">
        <div class="o-container">

            <app-intro class="u-d-flex align-items-center justify-content-between">
                <h3 class="u-mb-0">Vestigingen</h3>

                <app-button to="/admin/locations/add" class="c-btn c-btn--info">
                    Vestiging toevoegen

                    <svg xmlns="http://www.w3.org/2000/svg" width="14.875" height="14.875" viewBox="0 0 14.875 14.875">
                        <g fill="none" stroke="#fff" stroke-linecap="round" stroke-width="2">
                            <path d="M1 7.438h12.875"/>
                            <path d="M7.437 1v12.875"/>
                        </g>
                    </svg>
                </app-button>
            </app-intro>

            <loading v-bind:nodes="locations">Bezig met laden van de vestigingen...</loading>

            <transition-group class="g-cols:2>sm g-cols:3>md g-cols:2>lg g-cols:3>xl || g-gap:1-xs g-gap:1-sm>sm" name="fade" tag="section" v-if="locations.length">

                <router-link :to="`/admin/locations/${location.VestigingID}/update`" class="c-node" v-for="location in locations" :key="'location-' + location.VestigingID">
                    <h4 class="c-node__title">{{ location.Vestigingsnaam }}</h4>
                    <ul class="c-node__list">
                        <li>{{ location.Vestigingsadres }}</li>
                        <li>{{ location.Contactpersoon }}</li>
                    </ul>
                </router-link>

            </transition-group>

            <div v-else>
                <p>Er zijn nog geen vestigingen aangemaakt. Maak er <router-link to="/admin/locations/add">hier</router-link> een aan.</p>
            </div>

        </div>
    </section>
</template>

<script>
    import { mapState } from 'vuex';
    import AppButton from '../../components/app/AppButton.vue';
    import AppIntro from '../../components/app/AppIntro.vue';
    import Loading from '../../components/Loading.vue';

    export default {
        components: { AppButton, AppIntro, Loading },
        data () {
            return {

            };
        },
        computed: {
            ...mapState({
                locations: (state) => state.location.list,
            }),
        },
        created () {
            this.$store.dispatch('location/list');
        },
    };
</script>

<style lang="scss" scoped>
    @import "../../assets/scss/_essentials.scss";

    /*.table {
        @include media-breakpoint-only(sm) {
            grid-template-columns: rem(150) 1fr;
            margin: 0;
            max-width: 100%;
        }
    }*/
</style>
